import { IUserAddress } from "@interface/customerDetails/IAddress";

export interface ICustomerDetailsForm {
    billingAddress: IUserAddress;
    birthDate: string;
    deliveryAddress: IUserAddress;
    email: string;
    emailConfirm: string;
    firstName: string;
    isSameDeliveryAddress: boolean;
    contactPermissions: IMarketingPreferencesForm;
    lastName: string;
    mobileNumber: string;
    privacyPolicy: boolean;
}

export interface IMarketingPreferencesForm {
    allowThirdParty: IPermissionNameValue;
    noLongerCustomer: IPermissionNameValue;
    activeCustomer: IPermissionNameValue;
}

export type IPermissionNameValue = Record<keyof typeof EPermissions, boolean>;

export enum EPermissions {
    ALLOW_EMAIL_CONTACT = "ALLOW_EMAIL_CONTACT",
    ALLOW_SMS_CONTACT = "ALLOW_SMS_CONTACT",
    ALLOW_PHONE_CONTACT = "ALLOW_PHONE_CONTACT",
    ALLOW_DIRECT_MAIL_CONTACT = "ALLOW_DIRECT_MAIL_CONTACT",
}
